import { motion, useInView } from "motion/react"
import { useRef } from "react";



const Lentes = () => {

    const ref = useRef(null);
    const isInView = useInView(ref, { once: false, margin: "-100px" });


    const items = [
        {
            img: "/img/plandepago.png",
            title: "Plan de pago a crédito mediante convenio empresarial",

        },
        {
            img: "/img/examen_vista.png",
            title: "Examen de la vista profesional para niños y adultos",
        },
        {
            img: "/img/materialesopticos.png",
            title: "Materiales ópticos (micas) de alta calidad",
        },
        {
            img: "/img/armazonesoys.png",
            title: "Armazones oftálmicos y solares de las mejores marcas",
        },
        {
            img: '',
            title: "Detección de patologías oculares",
            text: "Evaluación profesional para identificar posibles enfermedades visuales.",
        },
        {
            img: '',
            title: "Adaptación de todo tipo de lente de contacto",
            text: "Ajuste personalizado para garantizar comodidad y visión óptima.",
        },
        {
            img: '',
            title: "Asesoría de armazón según tu estilo y rostro",
            text: "Te ayudamos a elegir el armazón ideal según tu tipo de rostro y estilo personal.",
        },
    ];

    return (
        <div className="container my-5" ref={ref}>
            <div className="row text-center mb-4">
                <h2 className="fw-bold text-uppercase tracking-wide">Te Ofrecemos</h2>
            </div>


            <div className="row justify-content-center">
                {items.filter(item => item.img !== '').map((item, i) => (
                    <motion.div
                        key={i}
                        className="col-lg-3 col-md-3 col-sm-6 p-3 rounded-3 bg-white"
                        initial={{ opacity: 0, y: 50 }}
                        exit={{ opacity: 0, y: -50 }}
                        animate={isInView ? { opacity: 1, y: 0 } : {}}
                        transition={{ duration: 0.6, delay: i * 0.2 }}
                        style={{ borderRadius: "20px", }}
                    >
                        <img
                            src={item.img}
                            alt={item.title}
                            className="img-fluid mb-3"
                            style={{ width: "100%", height: "180px", objectFit: "contain" }}
                        />
                        <h5 className="fw-bold text-center">{item.title}</h5>
                    </motion.div>
                ))}
            </div>
            <div className="row text-center mt-5 mb-4">
                <h2 className="fw-bold text-uppercase tracking-wide">Servicios Adicionales</h2>
            </div>


            <div className="row justify-content-center gap-4">
                {items.filter(item => item.img === '').map((item, i) => (
                    <motion.div
                        key={i}
                        className="col-md-3 col-sm-8 p-4 rounded-3 shadow-sm bg-white"
                        initial={{ opacity: 0, y: 50 }}
                        animate={isInView ? { opacity: 1, y: 0 } : {}}
                        exit={{ opacity: 0, y: -50 }}
                        transition={{ duration: 0.6, delay: i * 0.2 }}
                        style={{ borderRadius: "20px" }}
                    >
                        <h5 className="fw-bold mb-2">{item.title}</h5>
                    </motion.div>
                ))}
            </div>
        </div>
    )

}

export default Lentes